import {useCallback, useSyncExternalStore} from 'react';

/** Ключ прежний: кто уже нажал «Принять» в старом баннере, уведомление второй раз не увидит */
const STORAGE_KEY = 'cookie-consent';
const CHANGE_EVENT = 'cookie-consent-change';
const TTL = 365 * 24 * 60 * 60 * 1000;

/** до гидрации неизвестно, видел ли посетитель уведомление: html страницы одинаков для всех и кешируется */
const PENDING = 'pending';
type Snapshot = 'seen' | 'none' | typeof PENDING;

function read(): Snapshot {
	try {
		const raw = window.localStorage.getItem(STORAGE_KEY);
		if (!raw) return 'none';
		const {value, expires} = JSON.parse(raw);
		if (value === 'accepted' && expires > Date.now()) return 'seen';
	} catch {
		// хранилище может быть недоступно: тогда уведомление показывается на каждой странице до закрытия
	}
	return 'none';
}

function write() {
	try {
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify({value: 'accepted', expires: Date.now() + TTL}));
	} catch {
		// см. read
	}
	window.dispatchEvent(new Event(CHANGE_EVENT));
}

const subscribe = (callback: () => void) => {
	window.addEventListener(CHANGE_EVENT, callback);
	window.addEventListener('storage', callback);
	return () => {
		window.removeEventListener(CHANGE_EVENT, callback);
		window.removeEventListener('storage', callback);
	};
};

/** Видел ли посетитель уведомление о cookie: да, ещё нет ('none') или неизвестно до гидрации ('pending') */
export function useCookieConsent() {
	const notice = useSyncExternalStore<Snapshot>(subscribe, read, () => PENDING);
	const dismiss = useCallback(() => write(), []);
	return {notice, dismiss};
}
